import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import dayjs from 'dayjs';
import type { HistoricoArete } from '../../api-client/pre-compras/aretes.dto';
import AppDialog from './AppDialog';

interface HistorialAreteDialogProps {
  titulo: string;
  open: boolean;
  onClose: () => void;
  historial: Array<HistoricoArete>;
  formatter: (arete: string) => string;
}

const HistorialAreteDialog = ({ open, onClose, titulo, historial, formatter }: HistorialAreteDialogProps) => {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={titulo}
      children={
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 400 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Arete Anterior</TableCell>
                <TableCell>Fecha Cambio</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historial.map((registro, index) => (
                <TableRow key={index}>
                  <TableCell>{formatter(registro.arete)}</TableCell>
                  <TableCell>{dayjs(registro.fechaHora).format('DD MMM YYYY - hh:mm A').toLocaleUpperCase()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
      buttons={
        <Button onClick={onClose} color="primary" variant="contained">
          Cerrar
        </Button>
      }
    />
  );
};

export default HistorialAreteDialog;
